import { library } from '@fortawesome/fontawesome-svg-core';
import { fab, faFacebookF, faTwitter, faLinkedinIn, faInstagram, faCodepen } from '@fortawesome/free-brands-svg-icons';
import { faCheckSquare, faPhone, faArrowRight, faSpinner, faExternalLinkAlt, faCoffee, faUser, faBars, faSquare, faMapMarkerAlt, faGlobe, faPhoneAlt, faSave, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Switch, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Aos from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import Work from './components/Work';
import About from './components/About';
import Contact from './components/Contact';
import ShowGlass from './components/ShowGlass';
import Footer from './components/Footer';
import { motion } from "framer-motion";
import { Scrollbars } from 'react-custom-scrollbars';

library.add(fab, faCloudUploadAlt, faPhone, faSpinner,  faExternalLinkAlt, faArrowRight, faSave, faGlobe, faPhoneAlt, faSquare, faBars, faCheckSquare, faUser, faMapMarkerAlt, faCoffee, faFacebookF, faTwitter, faLinkedinIn, faInstagram);




function App() {

  const [loading, setLoading] = useState(!false);

  

  useEffect( () => {
    demoAsyncCall().then(() => setLoading(false));
  }, [loading])

  useEffect( () => {
    Aos.init({duration: 3000, offset: 400})
  }, [])

  
  return (
    loading ? <div className='loader'></div> : (
    // <Scrollbars style={{width: '100%', height: '100%'}}>
    <motion.div style={{
      backgroundColor: 'rgb(10,25,47)',
      color: 'rgb(136,146,176)'
    }} className="parent-containerr">
      <div className='social-div' >
            <div className='socials'>
                <a href='https://www.linkedin.com/in/tosin-samuel-alagbada-95874b106/' target='_blank'><FontAwesomeIcon icon={["fab", "linkedin"]} /></a>
                <a href='https://github.com/Alat-star' target='_blank'><FontAwesomeIcon icon={["fab", "github"]} /></a>
                <a href='#' target='_blank'><FontAwesomeIcon icon={["fab", "twitter"]} /></a>
                <a href='#' target='_blank'><FontAwesomeIcon icon={["fab", "facebook-f"]} /></a>
                <a href='https://codepen.io/your-work' target='_blank'><FontAwesomeIcon icon={["fab", "codepen"]} /></a>
            </div>
        </div>
        <div  className='mail-div'>
              <a  href='mailto:alagbadatosin@gmail.com'>hello@tosinalagbada.dev</a>
        </div>
      <Header />
      <Home />
      <div id='about' ><About  /></div>
      <div id='work' data-aos='fade-right'><Work /></div>
      <div id='exp' data-aos='fade-left'><ShowGlass /></div>
      <div id='contact' data-aos='flip-right'><Contact /></div>
        <Footer />
    </motion.div>)
  );
}

function demoAsyncCall() {
  return new Promise((resolve) => setTimeout(() => resolve(), 1500));
}

export default App;
